module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/cash_funds-9bd5fa21a0f3934cd99ed4a6cbee4d9b.svg";